/* eslint-disable */
export default {
  cancel: 'Cancel',
  confirm: 'Confirm',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
